import {
  SET_REGISTER_INFO,
  SET_PROCESS_REGISTER,
} from '@/stores/types/register/actions.type';
import {
  UPDATE_REGISTER_INFO,
  UPDATE_PROCESS_REGISTER,
} from '@/stores/types/register/mutations.type';
import {
  REGISTER_INFO,
  PROCESS_REGISTER,
} from '@/stores/types/register/getter.type';
import registerService from '@/apis/registers/registersAPI';

const state = {
  registerInfo: {},
  processRegister: {},
};

const getters = {
  [REGISTER_INFO](state) {
    return state.registerInfo;
  },
  [PROCESS_REGISTER](state) {
    return state.processRegister;
  },
};

const actions = {
  [SET_REGISTER_INFO]({ commit }, registerInfo) {
    // commit(UPDATE_REGISTER_INFO, registerInfo);
    if (registerInfo) {
      return registerService.doRegisterInfo(registerInfo).then((res) => {
        if (res && res.Success) {
          commit(UPDATE_REGISTER_INFO, registerInfo);
        }
        return res;
      });
    }
  },

  [SET_PROCESS_REGISTER]({ commit }, processRegister) {
    commit(UPDATE_REGISTER_INFO, processRegister);
  },
};

const mutations = {
  [UPDATE_REGISTER_INFO](state, registerInfo) {
    state.registerInfo = registerInfo;
  },

  [UPDATE_PROCESS_REGISTER](state, processRegister) {
    state.processRegister = processRegister;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
